import { TanStackDevtools } from '@tanstack/react-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { fetchAuthSession, type AuthSession } from 'aws-amplify/auth';

import { Toaster } from '@components/ui/toaster';
import { Tooltip } from '@components/ui/tooltip';
import { ThemeProvider } from '@contexts/theme.context';

import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';

interface MyRouterContext {
  auth: {
    isAuthenticated: boolean;
    session?: AuthSession;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  beforeLoad: async () => {
    const session = await fetchAuthSession();
    return {
      auth: {
        isAuthenticated: !!session.tokens,
        session: session.tokens,
      },
    };
  },
  component: RootComponent,
  notFoundComponent: () => <div>404 - Not Found</div>,
});

function RootComponent() {
  return (
    <ThemeProvider>
      <Tooltip.Provider delayDuration={250}>
        <Outlet />
      </Tooltip.Provider>
      <Toaster />
      <TanStackDevtools
        config={{
          openHotkey: ['ctrl-h'],
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </ThemeProvider>
  );
}
